import { isPositiveNumber } from "et3-type-guards";
import { memoize } from "lodash";
import { observable } from "mobx";

import { USER_ADVANCED_PAGE_LINK } from "../../../constants/core-constants";
import getUserAdvancedStore from "../../user-store/advanced-store";
import getCoreNavigationStore from "../core-navigation-store";
import getCoreUIStore from "../core-ui-store";

class CoreSideMenuStore {
  sideBarSearchText = observable.box<number>(-1);

  submitSearch = () => {
    getCoreNavigationStore().navigateToPage(
      USER_ADVANCED_PAGE_LINK,
      `?id=${this.sideBarSearchText.get()}`
    );
    this.handleSearch();
  };

  handleSearch = async () => {
    getCoreUIStore().setIsSearchPopoverVisible(false);
    const userID = this.sideBarSearchText.get();
    const isDefinedUserId = isPositiveNumber(userID);
    if (!isDefinedUserId) {
      return;
    }
    getUserAdvancedStore().setSearchType("option_search");
    getUserAdvancedStore().setSearchByInput("userId");
    getUserAdvancedStore().advancedSearchInput.set(userID);
    await getUserAdvancedStore().getUserData(false);
  };
}
const getCoreSideMenuStore = memoize(
  () => new CoreSideMenuStore(),
  () => 1
);
export default getCoreSideMenuStore;
